module.exports = __webpack_public_path__ + "static/media/web_buttons_increase_sales.348c5b6d.svg";